/*
 * @fileOverView Form component definition
 */

import 'jquery-validation';
import 'what-input';
import Bowser from "bowser";
// Bowser relies on Array.prototype.find().
require('array.prototype.find').shim();

export default {
  name: 'form',
  data: function () {
    return {
      form: null,
      invalidBrowser: false,
      // Used by submit buttons to toggle display of loading feedback.
      isLoading: false
    }
  },

  mounted() {
    this.form = $(this.$refs.form);

    if (this.form) {
      this.initializeValidator();
    }

    if (this.$refs.browserAlert && this.isBrowserInvalid()) {
      this.invalidBrowser = true;
    }
  },

  destroy() {
    this.validator.destroy();
  },

  methods: {
    /**
     * Detect whether the browser supports TLS 1.2.
     *
     * Note: The site has not been fully tested in all "valid" browsers, such as
     * the Android browser, Opera, and older versions of Chrome, Firefox, etc.
     */
    isBrowserInvalid() {
      const browser = Bowser.getParser(window.navigator.userAgent);

      return browser.satisfies({
        'android browser': '<=~4',
        chrome: '<=29',
        firefox: '<=40',
        'internet explorer': '<=10',
        opera: '<=16',
        safari: '<=9',
        ios: {
          firefox: '<=15'
        }
      });
    },

    /**
     * Initializes jQuery validation on form submission.
     */
    initializeValidator() {
      this.validator = this.form.validate({
        errorClass: 'js-error',
        ignore: '.js-validation-exempt input:hidden, .js-validation-exempt textarea:hidden',
        highlight: this.validatorHighlight,
        unhighlight: this.validatorUnhighlight,
        submitHandler: this.handleValidSubmission,
        invalidHandler: this.handleInvalidSubmission
      });
    },

    /**
     * Signals a field with a validation error.
     */
    validatorHighlight(element, errorClass, validClass) {
      $(element).closest('.field').addClass('field_error');
    },

    /**
     * Removes the signal from a field with a validation error.
     */
    validatorUnhighlight(element, errorClass, validClass) {
      $(element).closest('.field').removeClass('field_error');
    },

    /**
     * Submits the form after successful validation.
     */
    handleValidSubmission(form) {
      this.submit(form);
    },

    /**
     * Signals a form with a validation error.
     */
    handleInvalidSubmission(event, validator) {
      this.form.addClass('js-validation-performed');

      // If this form is also using the analytics mixin, report the errors.
      if (this.pushFormValidationFailedEvent) {
        this.pushFormValidationFailedEvent(validator.errorMap);
      }
    },

    /**
     * Handles form submission. Should be overriden for custom form bahavior.
     *
     * @param {object} form
     *   The form object
     */
    submit(form) {
      form.submit();
    }
  }
};
